import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import Config from '@/config';
import RouterUtil from '@/utils/RouterUtil';
import NavBar from '@/view/components/nav-bar/nav-bar.vue';
import StorageUtil from '@/utils/StorageUtil';
import AMapUtil from '@/utils/AMapUtil';
export default {
  name: 'Address',
  components: {
    NavBar
  },
  setup() {
    const title = ref('选择地址');
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const placeSearch = shallowRef();
    const placeNearSearch = shallowRef();
    const position = ref();
    const provinceName = ref('');
    const cityName = ref('');
    const districtName = ref('');
    const cityCode = ref('');
    const addressType = ref('start');
    const keyword = ref('');
    const pois = ref([]);
    return {
      title,
      map,
      geolocation,
      geocoder,
      placeSearch,
      placeNearSearch,
      position,
      provinceName,
      cityName,
      districtName,
      cityCode,
      addressType,
      keyword,
      pois
    };
  },
  mounted() {
    this.getStorageData();
    this.initMap();
    try {
      const cityData = StorageUtil.getObject('cityData');
      if (cityData) {
        this.position = cityData.center;
      }
    } catch (e) {
      console.log(e);
    } finally {
      StorageUtil.remove('cityData');
    }
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.PlaceSearch']
      }).then(AMap => {
        this.map = new AMap.Map('address-map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.placeSearch = new AMap.PlaceSearch({
          //设置PlaceSearch属性
          city: '',
          //城市
          type: '',
          //数据类别
          pageSize: 30,
          //每页结果数,默认10
          pageIndex: 1,
          //请求页码，默认1
          extensions: 'base' //返回信息详略，默认为base（基本信息）
        });
        this.placeNearSearch = new AMap.PlaceSearch({
          //设置PlaceSearch属性
          city: '',
          //城市
          type: '',
          //数据类别
          pageSize: 30,
          //每页结果数,默认10
          pageIndex: 1,
          //请求页码，默认1
          extensions: 'base' //返回信息详略，默认为base（基本信息）
        });
        this.getAddress(this.position);
      }).catch(e => {
        console.error(e);
      });
    },
    getAddress(position) {
      const that = this;
      AMapUtil.getAddress(this.geocoder, position).then(function (result) {
        var _result$result;
        // console.log("result===" + JSON.stringify(result))
        if (result.districtName.endsWith('市') || result.districtName.endsWith('县')) {
          that.placeSearch.setCity(result.adCode);
        } else {
          that.placeSearch.setCity(result.cityCode);
        }
        that.cityCode = result.adCode;
        that.provinceName = (_result$result = result.result) === null || _result$result === void 0 || (_result$result = _result$result.regeocode) === null || _result$result === void 0 || (_result$result = _result$result.addressComponent) === null || _result$result === void 0 ? void 0 : _result$result.province;
        that.cityName = result.cityName;
        that.districtName = result.districtName;
        that.goPlaceSearchNearBy();
      }).catch(function (error) {
        that.cityName = '未知地区';
        console.error('根据经纬度查询地址失败：' + error);
      });
    },
    goPlaceSearch() {
      const that = this;
      that.placeSearch.search(that.keyword, function (status, result) {
        if (status === 'complete') {
          const poiData = result.poiList.pois;
          that.pois = [];
          for (let i = 0; i < poiData.length; i++) {
            that.pois.push(poiData[i]);
          }
        }
      });
    },
    goMapSelect() {
      RouterUtil.go('/address/map-select', true, this.$route.path);
    },
    goPlaceSearchNearBy() {
      const that = this;
      let apiSearch = that.placeSearch;
      let radius = 200;
      if (that.addressType === 'end') {
        apiSearch = that.placeNearSearch;
        radius = 5000;
      }
      apiSearch.searchNearBy('', this.position, radius, function (status, result) {
        if (status === 'complete') {
          const poiData = result.poiList.pois;
          that.pois = [];
          for (let i = 0; i < poiData.length; i++) {
            that.pois.push(poiData[i]);
          }
        }
      });
    },
    async selectAddress(index) {
      const that = this;
      let orderCityCode = this.cityCode;
      await AMapUtil.getAddress(this.geocoder, this.pois[index].location).then(function (result) {
        orderCityCode = result.adCode;
      });
      StorageUtil.setObject('addressData', {
        type: that.addressType,
        cityCode: orderCityCode,
        provinceName: that.provinceName,
        cityName: that.cityName,
        districtName: that.districtName,
        address: that.pois[index].name,
        position: that.pois[index].location
      });
      RouterUtil.back();
    },
    getStorageData() {
      try {
        const positionData = StorageUtil.getObject('positionData');
        if (positionData) {
          if (positionData.type) {
            this.addressType = positionData.type;
          }
          this.position = positionData.position;
        } else {
          this.position = Config.defaultPosition;
        }
      } catch (e) {
        this.position = Config.defaultPosition;
      } finally {
        // StorageUtil.remove("positionData");
        if (this.addressType === 'start') {
          this.title = '选择上车点地址';
        }
        if (this.addressType === 'end') {
          this.title = '选择下车点地址';
        }
      }
    },
    goBack() {
      RouterUtil.back();
    },
    goHome() {
      RouterUtil.home();
    },
    goSelectCity(type) {
      // StorageUtil.setObject("positionData", {
      //     type: type,
      //     position: this.position,
      // });
      RouterUtil.go('/city', false, this.$route.path);
    },
    goCommute() {
      RouterUtil.go('/user/commute', false, this.$route.path);
    }
  }
};